// Shop filter drawer — opens the sidebar as an off-canvas drawer on tablet/mobile.

export function initShopSidebar() {
	const sidebar = document.querySelector('[data-cs-shop-sidebar]');
	const opener = document.querySelector('[data-cs-sidebar-open]');
	const closer = document.querySelector('[data-cs-sidebar-close]');
	const backdrop = document.querySelector('[data-cs-sidebar-backdrop]');
	if (!sidebar || !opener) return;

	const setOpen = (isOpen) => {
		sidebar.classList.toggle('is-open', isOpen);
		opener.setAttribute('aria-expanded', String(isOpen));
		if (backdrop) {
			backdrop.hidden = false; // ensure backdrop element is in the flow
			backdrop.classList.toggle('is-visible', isOpen);
		}
		document.documentElement.style.overflow = isOpen ? 'hidden' : '';
	};

	opener.addEventListener('click', () => setOpen(true));
	closer?.addEventListener('click', () => setOpen(false));
	backdrop?.addEventListener('click', () => setOpen(false));

	// Close on Escape
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
			setOpen(false);
		}
	});
}
